import React, { useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { IFormsModalProps } from '../../../interfaces/interfaces';
import keyboardTriggerBasic from '../../../utils/keyboard-trigger';
import randomId from '../../../utils/randomId';
import Link from '../Link/Link';

function FormsModal(props: IFormsModalProps): JSX.Element {
  const { t } = useTranslation();
  const modalRef = useRef<HTMLAnchorElement>(null);
  const { onAbort, forms } = props;
  useEffect(() => {
    modalRef.current?.focus();
  }, []);
  const onAbortClick = () => {
    // close modal
    onAbort();
  };

  const modalContent = (
    <>
      <ul className="list">
        {forms?.map((link) => (
          <li key={randomId('favourite-list')}>
            <Link
              linkHref={link.link}
              linkText={
                (link.title_short && (typeof link.title_short === 'string' ? link.title_short : link.title_short[0])) ||
                (typeof link.title === 'string' ? link.title : link.title[0])
              }
              linkClass="link ic-download"
            />
            <div className="link-note">
              ({link.media_type.length > 0 ? `${link.media_type[0].toUpperCase()}, ` : ''}
              {link.document_filesize},{' '}
              {link.is_barrier_free ? t('cockpit.forms.accessible') : t('cockpit.forms.nonaccessible')})
            </div>
          </li>
        ))}
      </ul>
    </>
  );

  return (
    <>
      <div className="modal forms-list-modal" role="dialog">
        <div className="modal-inner l-container">
          <a
            role="button"
            className="modal-closer"
            onClick={onAbortClick}
            onKeyDown={(e) => {
              keyboardTriggerBasic(e, onAbortClick);
            }}
            tabIndex={0}
          >
            <span className="ic-close" />
          </a>

          <div className="modal-inner-content">
            <h3 className="hl-3">
              <Trans i18nKey="cockpit.forms.modalHeadline">Formularübersicht</Trans>
            </h3>
            <div className="scrollable-content">{modalContent}</div>
          </div>
        </div>
      </div>
    </>
  );
}
export default FormsModal;
